import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import { FaBars, FaTimes } from 'react-icons/fa';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  // Function to close menu on click (Smooth Scrolling)
  const handleLinkClick = () => {
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header className="header">
      <div className="container">
        <div className="navbar">
          {/* Logo */}
          <Link to="/" className="brand-logo" onClick={handleLinkClick}>
            <img src="/logo.webp" alt="Logo" className="logo" loading="lazy" />
          </Link>

          {/* Mobile Menu Toggle */}
          <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <FaTimes /> : <FaBars />}
          </div>

          {/* Navigation Menu */}
          <nav className={`nav-links ${menuOpen ? "nav-open" : ""}`}>
            <Link to="/" className="nav-item" onClick={handleLinkClick}>Home</Link>
            <Link to="/about" className="nav-item" onClick={handleLinkClick}>About Us</Link>
            <Link to="/services" className="nav-item" onClick={handleLinkClick}>Services</Link>
            <Link to="/contact" className="nav-item" onClick={handleLinkClick}>Contact Us</Link>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
